/* jshint esversion: 6 */

import GtmService from '../gtm/gtm.service';

class ContactsCtrl {

	constructor(
		$scope,
		$location,
		$timeout,
		$http,
		StateService
	) {
		this.$scope = $scope;
		this.$location = $location;
		this.$timeout = $timeout;
		this.$http = $http;
		this.data = window.data || {};
		this.model = {};
		if (this.$location.search() && this.$location.search().email) {
			this.model.email = this.$location.search().email;
		}
		this.state = StateService.getState();
		this.state.ready();
	}

	setProvinces() {
		this.$timeout(() => {
			this.provinces = this.data.provinces.filter(x => x.countryId === this.model.Nazione);
		});
	}

	onSubmit() {
		var inputCaptcha = document.getElementById('g-recaptcha-response');
		if (inputCaptcha) {
			this.model.Captcha = inputCaptcha.value;
		} else {
			this.model.Captcha = '';
		}

		console.log('ContactsCtrl.onSubmit', this.model);
		if (this.state.busy()) {
			this.$http.post('/WS/wsUsers.asmx/Contact', { data: this.model }).then(
				success => {
					if (success.data.d.Status) {
						this.state.success();

						const obj = Object.assign({}, window.objDataLayerInfo);
						obj["eventname"] = "contact_us_request_sent";
						obj["label"] = success.data.d.Props.motivoEN;
						GtmService.push(obj);

					}
					else {
						this.state.error();
					}
				},
				error => {
					this.error = error;
				}
			);

			this.$timeout(() => {
				// this.state.ready();
			}, 2000);
		}
	}

	onInvalid() {
		this.$scope.$broadcast('onInvalid');
	}

}

ContactsCtrl.$inject = ['$scope', '$location', '$timeout', '$http', 'StateService'];

export default ContactsCtrl;
